<div class="eui-app-sidebar-content" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave($event)" role="complementary">
    <ng-content select="eui-app-sidebar-header-user-profile"></ng-content>
    <ng-content select="eui-app-sidebar-header"></ng-content>
    <ng-content select="eui-app-sidebar-body"></ng-content>
    <ng-content select="eui-app-sidebar-footer"></ng-content>
    <ng-content select="eui-app-sidebar-drawer"></ng-content>
</div>
